import Vue from 'vue';

Vue.component('innovation-library', () =>
  import(/* webpackChunkName: "innovation-library" */ './Library.vue')
);
